﻿import { exact, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const translationType = exact({
  id: string.isRequired,
  fallback: string.isRequired,
});
